import { styled, Box, IconButton } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const UploadImageContainer = styled('div')({
  width: '100%',
  height: 'fit-content',
  position: 'relative',
});

export const CustomActioButtons = styled(IconButton)(({ isDrag }: { isDrag?: boolean }) => ({
  position: 'absolute',
  background: isDrag ? COLORS.PRIMARY : COLORS.ERROR,
  fontSize: 12,
  padding: 10,
  right: isDrag ? 'unset' : 10,
  left: isDrag ? 10 : 'unset',
  top: 5,
  zIndex: 9999,
  '&:hover': {
    backgroundColor: isDrag ? COLORS.PRIMARY : COLORS.ERROR,
  },
}));
